import { CheckboxProps, default as MaterialUICheckbox } from '@material-ui/core/Checkbox';
import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import styled, {
  css,
  FlattenInterpolation,
  FlattenSimpleInterpolation,
  ThemeProps,
} from 'styled-components';
import { Box } from '~common/components/box.component';
import { Span } from '~common/components/span.component';

interface CheckBoxInputProps extends FieldRenderProps<boolean>, CheckboxProps {
  label?: string;
  onChangeHandler?: (checked: boolean, event?: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Checkbox: React.FunctionComponent<CheckBoxInputProps> = ({
  input,
  meta,
  label,
  onChangeHandler,
  disabled,
  ...rest
}) => {
  const { name, onChange, checked, onFocus, onBlur } = input;

  return (
    <Container className={'checkbox-container'}>
      <MaterialUICheckbox
        name={name}
        onChange={(event, checked): void => {
          onChange(event);
          onChangeHandler?.(checked, event);
        }}
        checked={checked}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        {...rest}
      />
      <Label disabled={disabled}>{label}</Label>
    </Container>
  );
};

const Container = styled(({ containerStyle, ...rest }) => <Box {...rest} />)<{
  containerStyle: FlattenInterpolation<ThemeProps<any>>;
}>`
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  ${(props): FlattenInterpolation<ThemeProps<any>> => props.containerStyle};
`;

const Label = styled(({ disabled, ...rest }) => <Span {...rest} />)<{
  disabled: boolean;
}>`
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  letter-spacing: 0.3px;
  user-select: none;

  ${(props): FlattenSimpleInterpolation | null =>
    props.disabled &&
    css`
      opacity: 0.5;
    `};
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/form/checkbox-input.component.tsx